import api from '../api/axios';
import { API_ENDPOINTS } from './api.config';

export const suggestionService = {
  // Get homepage suggestions (doctors, medicines, services, test packages)
  getSuggestions: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.GENERAL);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch suggestions' };
    }
  },

  // Get doctors for a specific medicine
  getDoctorsForMedicine: async (medicineId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.DOCTORS_FOR_MEDICINE(medicineId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch doctors for medicine' };
    }
  },

  // Get medicines recommended by a doctor
  getMedicinesForDoctor: async (doctorId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.MEDICINES_FOR_DOCTOR(doctorId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch medicines for doctor' };
    }
  },

  // Get services recommended by a doctor
  getServicesForDoctor: async (doctorId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.SERVICES_FOR_DOCTOR(doctorId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch services for doctor' };
    }
  },

  // Get tests recommended by a doctor
  getTestsForDoctor: async (doctorId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.TESTS_FOR_DOCTOR(doctorId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch tests for doctor' };
    }
  },

  // Get related medicines
  getRelatedMedicines: async (medicineId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.RELATED_MEDICINES(medicineId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch related medicines' };
    }
  },

  // Get related services
  getRelatedServices: async (serviceId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.RELATED_SERVICES(serviceId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch related services' };
    }
  },

  // Get suggestions for paramedical service
  getForParamedicalService: async (serviceId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.FOR_PARAMEDICAL_SERVICE(serviceId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch paramedical service suggestions' };
    }
  },

  // Get related tests
  getRelatedTests: async (testId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.RELATED_TESTS(testId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch related tests' };
    }
  },

  // Get packages for a specific test
  getPackagesForTest: async (testId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.PACKAGES_FOR_TEST(testId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch packages for test' };
    }
  },

  // Get related test packages
  getRelatedPackages: async (packageId) => {
    try {
      const response = await api.get(API_ENDPOINTS.SUGGESTIONS.RELATED_PACKAGES(packageId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch related packages' };
    }
  },
};

export default suggestionService;
